import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-12\"><h1 class=\"text-center\">Paiement réussi 🎉</h1></div></div><div class=\"row\"><div class=\"col-12\"><p class=\"text-center\"> Votre paiement a bien été pris en compte. <br> Vous pouvez maintenant accéder à votre espace personnel. </p></div></div>", 2)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Accéder à mon espace personnel ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}